function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-3550.318 -2895.393)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12.383,
  cy: 12.383,
  r: 12.383,
  transform: "translate(3550.318 2895.393)",
  fill: "#fbb03b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3565.1,2916v-1.547h-1.546v-1.546h.955a1.546,1.546,0,0,0,1.534-1.354l.024-.192h1.784a1.545,1.545,0,0,0,1.467-1.057l1.194-3.581h-3.866l.774-6.184h-9.277l.773,6.184h-3.865l1.194,3.581a1.546,1.546,0,0,0,1.466,1.057h1.785l.024.192a1.545,1.545,0,0,0,1.534,1.354h.954v1.546h-1.546V2916Zm-7.649-6.713-.339-1.018h2l.194,1.546h-1.118A.775.775,0,0,1,3557.45,2909.288Zm3.506,1.4-1.075-8.6h5.8l-1.075,8.6a.772.772,0,0,1-.767.677h-2.114A.774.774,0,0,1,3560.956,2910.685Zm5.3-.869.193-1.546h2l-.339,1.018a.774.774,0,0,1-.733.528Z",
  fill: "#f2f3f8"
}));

var SvgRohFirstPlace = function SvgRohFirstPlace(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.766,
    height: 24.766,
    viewBox: "0 0 24.766 24.766",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRohFirstPlace, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/roh-first-place.02913e8a.svg";
export { ForwardRef as ReactComponent };